import { jsx as _jsx } from "react/jsx-runtime";
import { _className, Button, ComponentSync, openContent } from '@nu-art/thunderstorm-frontend';
import { Component_ContentFallback } from '../../Component_ContentFallback/Component_ContentFallback.js';
import { ICONS } from '@app/styles';
import { ModuleFE_AdvisorMini } from '../../../../modules/ModuleFE_AdvisorMini.js';
import { PanelKey_Home, PanelKey_SmartDocs } from '@app/advisor-v5-shared';
import { ModuleFE_AdvisorAnalytics } from '../../../../_analytics/consts.js';
import './Component_LiveMDMButton.scss';
import { AdvisorConfigKeyFE_SmartDocs_NoteIds, ModuleFE_RuntimeSmartNote } from '@app/advisor-frontend';
import { Debounce } from '@nu-art/ts-common';
import { Board_SmartDocs } from '../../../../_enum.js';
import { Component_CreateNoteHoverLabel, Label_CreateNote } from '../../create-note-hover/Component_CreateNoteHoverLabel.js';
export class Component_LiveMDMButton extends ComponentSync {
    updateMDMDebouncer = new Debounce(() => this.updateMDM(), 300);
    //######################### Static #########################
    static modulesToAwait = [
        //Static Modules
        //Runtime Modules
        ModuleFE_RuntimeSmartNote,
    ];
    //######################### Life Cycle #########################
    __onRuntimeSmartNotesUpdated = () => this.updateMDMDebouncer.trigger();
    __onAdvisorMiniChange = () => {
        if (this.mounted)
            this.forceUpdate();
    };
    __onAdvisorBoardUpdated = (updates) => {
        if (this.mounted)
            this.forceUpdate();
    };
    deriveStateFromProps(nextProps, state) {
        state.forceFallback = !!nextProps.forceFallback;
        const latestMDM = this.getLatestMDM();
        state.latestMDMTimestamp = latestMDM?.__updated;
        state.mdmToView ??= false;
        return state;
    }
    //######################### Logic #########################
    onClick = async () => {
        let open = true;
        if (ModuleFE_AdvisorMini.getIsMiniActive()) { //Mini flow
            if (ModuleFE_AdvisorMini.getCurrentFocusedPanel() !== PanelKey_SmartDocs)
                ModuleFE_AdvisorMini.openPanel(PanelKey_SmartDocs);
            else {
                ModuleFE_AdvisorMini.openPanel(PanelKey_Home);
                open = false;
            }
        }
        else { //Full flow
            if (!Board_SmartDocs.isOpen())
                Board_SmartDocs.open();
            else {
                Board_SmartDocs.close();
                open = false;
            }
        }
        if (open) {
            ModuleFE_AdvisorAnalytics.trigger.view.view__liveMDM({ method: 'manual' });
            this.setState({ mdmToView: false });
        }
        else {
            this.forceUpdate();
        }
    };
    getLatestMDM() {
        const noteId = AdvisorConfigKeyFE_SmartDocs_NoteIds.get()?.mdm;
        return ModuleFE_RuntimeSmartNote.getLatestNote(noteId);
    }
    updateMDM = () => {
        const latestMDM = this.getLatestMDM();
        if (!latestMDM)
            return;
        if (!this.state.latestMDMTimestamp)
            return this.setState({ latestMDMTimestamp: latestMDM.__updated });
        if (latestMDM.__updated <= this.state.latestMDMTimestamp)
            return;
        //Enable: if you need the mdm toast to appear...
        // Toast_LiveMDM.toast('live-mdm', {
        // 	body: 'MDM has been updated',
        // });
        this.setState({
            latestMDMTimestamp: latestMDM.__updated,
            mdmToView: ModuleFE_AdvisorMini.getCurrentFocusedPanel() !== PanelKey_SmartDocs,
        });
    };
    isActive = () => {
        if (ModuleFE_AdvisorMini.getIsMiniActive())
            return ModuleFE_AdvisorMini.getCurrentFocusedPanel() === PanelKey_SmartDocs;
        return Board_SmartDocs.isOpen();
    };
    //######################### Render #########################
    render() {
        const className = _className('c__live-mdm-button', this.state.mdmToView && 'mdm-to-view', this.isActive() && 'active');
        return _jsx(Button, { onClick: this.onClick, className: className, variant: 'primary', ...(this.state.forceFallback && openContent.tooltip.top('tt__live-mdm-button', Label_CreateNote, { offset: 10 })), children: _jsx(Component_ContentFallback, { forceFallback: this.state.forceFallback, content: () => _jsx(Component_CreateNoteHoverLabel, { resting: 'Notes' }), fallback: () => _jsx(ICONS.advisor_avn_liveMdm.component, {}) }) });
    }
}
//# sourceMappingURL=Component_LiveMDMButton.js.map